import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import {defineState} from 'redux-localstore';

const defaultState = {
  dashboard: [],
  error: false,
  loading: false,
  lastSync: false
};

const initialState = defineState(defaultState)('dashboard');

const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.dashboard.length > 0 ? action.dashboard : [];  
  return updateObject(state, {
    dashboard: result,
    error: false,
    loading: false,
    lastSync: new Date()
  });
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, dashboard:[] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_DASHBOARD_START:
      return fetchStart(state);
    case actionTypes.FETCH_DASHBOARD_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_DASHBOARD_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false
      };
  }
};

export default reducer;
